<template>
  <section>
    <div class="card">
      <div class="card-header">ยืนยันตัวตน</div>
      <div class="card-body">
        <div class="form-horizontal ">
          <div class="form-group">
            <label class="control-label h5">ตัวอย่างรูป</label>
            <div class="row">
              <div class="col-sm-12">
                <h4 class="control-label h5">ขั้นตอนการถ่ายรูปคู่บัตรเพื่อยืนยันตัวตน</h4>
                <img src="/static/img/professional/beneat_pdpa.jpg" class="img-fluid pa-2"><br>
                <ul  style="list-style-type: '-';margin: 15px 20px;">
                  <li class="control-label font-size-li">&nbsp;บัตรต้องไม่บังใบหน้าส่วนใดส่วนหนึ่ง</li>
                  <li class="control-label font-size-li">&nbsp;อย่าใส่หมวกหรือแว่นตาดำ</li>
                  <li class="control-label font-size-li">&nbsp;อย่าใส่ที่คาดผมหรือเครื่องประดับ</li>
                  <li class="control-label font-size-li">&nbsp;อย่าถ่ายครึ่งหน้า</li>
                  <li class="control-label font-size-li">&nbsp;รูปต้องชัดเจนให้เห็นอักษรบนบัตร</li>
                </ul>
              </div>
            </div>
            <div class="row">
              <label class="control-label h5">รูปยืนยันตัวตน</label>
            </div>
            <div class="row">
              <div class="col-sm-12 ">
                <picture-input
                  ref="pictureInput"
                  width="400"
                  height="400"
                  accept="image/jpeg,image/png,image/gif,image/svg,image/webp"
                  size="5"
                  :removable="true"
                  :customStrings="{
                    upload: '<p>อัพโหลดเรียบร้อย</p>',
                    drag: 'อัพโหลดรูป',
                    tap: 'อัพโหลดรูป',
                    change: 'เปลี่ยนรูป',
                    remove: 'ลบรูป',
                  }"
                  :zIndex="1000"
                  @change="onChange"
                >
                </picture-input>
              </div>
            </div>
            <br>
            <div class="row">
              <label class="control-label col-sm-12 h5">ลายเซ็นต์ยืนยันตัวตน</label>
            </div>
            <div class="row">
              <div class="col-sm-12" style="text-align: center;">
                <canvas class="canvas-box land-signature-pad" ref="signaturePad"></canvas>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12">
                <button class="btn btn-outline-info btn-lg btn-block" @click="clearSignature()"><i class="fas fa-undo"></i> เขียนลายเซ็นต์ใหม่</button>
                <button
                  :class="['btn btn-success btn-lg btn-block mt-2', _.isEmpty(this.signaturePad._data) || isSubmitting ? 'disabled' : '']"
                  :disabled="_.isEmpty(this.signaturePad._data) || isSubmitting" @click="submitContractSignature">
                  {{ isSubmitting ? 'บันทึก...' : 'บันทึก' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import VueCoreImageUpload from 'vue-core-image-upload'
import SignaturePad from 'signature_pad'
import PictureInput from 'vue-picture-input'
import axios from 'axios'

export default {
  components: {
    VueCoreImageUpload,
    PictureInput
  },
  data: function () {
    return {
      url: '',
      headers: null,
      uploading: false,
      formData: {
        firstName: null,
        lastName: null,
        tel: null
      },
      options: {
        penColor: '#c0f'
      },
      signaturePad: '',
      isSubmitting: false
    }
  },
  computed: {
    isUploading () {
      return (this.uploading) ? 'message.button.uploading' : 'message.button.upload_picture'
    }
  },
  methods: {
    onChange (image) {
      console.log('New picture selected!')
      if (image) {
        console.log('Picture loaded.', image)
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!')
      }
    },
    clearSignature () {
      this.signaturePad.clear()
    },
    async submitContractSignature () {
      if (this.$refs.pictureInput.image === undefined || this.$refs.pictureInput.image === '') {
        this.$swal({
          text: 'พบข้อผิดพลาด กรุณาตรวจสอบรูปภาพ',
          type: 'error'
        })
        return
      }
      if (this.signaturePad.isEmpty()) {
        this.$swal({
          text: 'พบข้อผิดพลาด กรุณาระบุลายเซ็นต์',
          type: 'error'
        })
        return
      }
      this.isSubmitting = true
      let formData = new FormData()
      formData.append('id_card_img', this.$refs.pictureInput.image)
      formData.append('signature_img', this.signaturePad.toDataURL())

      try {
        await axios.post(`professionals/${this.$route.params.id}/sign-contract`, formData)

        this.isSubmitting = false
        this.$swal({
          text: 'บันทึกข้อมูลเสร็จสิ้น',
          type: 'success',
          onClose: () => {
            this.$router.replace({path: `/cleaner/${this.$route.params.id}/contracts/1`})
          }
        })
      } catch (err) {
        this.isSubmitting = false
        this.$swal({
          text: err.message,
          type: 'error'
        })
      }
    }
  },
  mounted () {
    let canvas = this.$refs.signaturePad
    this.signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgb(255, 255, 255)'
    })
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext('2d').scale(ratio, ratio)
  }
}
</script>

<style scoped>
.land-signature-pad {
  border: 1px solid salmon;
  border-radius: 25px;
  max-width: 400px;
}

.canvas-box {
  border-radius: 25px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 120px;
}
.font-size-li{
  font-size: 18px;
}
</style>




// WEBPACK FOOTER //
// src/components/professional/contract/ProfessionalContractIDCard.vue